export default "__VITE_ASSET__DXNHeX8Y__"